import styled from "styled-components";

export const ActionCardWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  background: #ffffff;
  border-radius: 14px;
  padding: 16px 18px;

  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.06);

  height: 140px;

  width: 100%;
  cursor: pointer;
`;

export const ActionCardMedia = styled.div`
  margin-right: 12px;
  pointer-events: none;
  img {
    width: 50px;
    height: 40px;
    object-fit: contain;
  }
`;

export const ActionCardBody = styled.div`
  flex: 1;
  height: 100%;

  display: flex;
  flex-direction: column;
`;

export const ActionCardProjectId = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 2px;
`;

export const ActionCardTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #0c1b3a;
`;

export const ActionCardDescription = styled.div`
  font-size: 14px;
  color: #4b5563;
  margin-top: 4px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ActionCardFooter = styled.div`
  margin-top: 10px;
  padding-top: 10px;

  font-size: 14px;
  font-weight: 500;
  color: #111827;

  border-top: 1px solid #e5e7eb;

  display: flex;
  align-items: center;
  gap: 10px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ActionCardArrow = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: auto;
  pointer-events: none;
`;
